import React from 'react';

import { useMediaQuery } from 'react-responsive';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { ApiObject, Country } from 'app/types';

import Text from 'common/components/Text/Text';

import styles from './Tabs.module.scss';

interface CompProps {
  country?: ApiObject<Country>;
}

const WorkAfterGraduation = ({ country }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={styles.workContainer}>
      {!isMobile && (
        <div className={styles.section}>
          <Text size={24} weight={700}>
            Work after graduation
          </Text>
        </div>
      )}
      {country?.data.work_after_studying && (
        <div className={styles.section}>
          <div className={styles.paragraph}>
            <Text color="primary" size={isMobile ? 14 : 16} inlineStyle={{ textAlign: 'justify' }}>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {country.data.work_after_studying}
              </ReactMarkdown>
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkAfterGraduation;
